import { resolveImageURL, isYouTubeUrl} from '../../../helpers/multimediaUtils';  
import PageHeaderBackground from '../../Molecules/PageHeaderBackground';
import {
  ContentNarrow,
  ContentWide,
  ContentWrapper,
  PageSection
} from 'volto-essvoltocomponents/components/Layout';
import RichText from '../../Atoms/RichText';

const CompetenceView = ({ content }) => {
  const title = content.title;
  const titleBgImageUrl =  resolveImageURL(content, "/@@images/hero_image/hero");
  const fullDescription = content.full_description?.data;
  const body = content.body?.data;
  return (
    <>
      <PageHeaderBackground
        title={title}
        description={fullDescription}
        showBackButton={true}
        backgroundImage={titleBgImageUrl}
        goBackText="Go back"
        blurBg={true}
      />
          
      {/* Body */}
      <PageSection paddingBottom="var(--ess-space-7xl)">
        <ContentWrapper>
          <ContentWide>
            <ContentNarrow>
              <RichText 
                content={body} 
                className="multimedia-item-body"/>
            </ContentNarrow>
          </ContentWide>
        </ContentWrapper>
      </PageSection>
    </>
  );
};

export default CompetenceView;
